import { Component, OnInit, Input, Inject } from '@angular/core';
import { IPRUpdatesModel } from '../../../../Models/IPRUpdatesModel';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { AppConfig } from '../../../../Services/app.config';
import { CheckAuth } from '../../../../Services/utility.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import * as FileSaver from 'file-saver';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { HtmlToPdf } from 'src/Services/htmlToPdf';
import { iprupdatesService } from 'src/Services/frontiprupdatesService';
import { IPRupdatesPageModel, IPRupdatesPageModelV2 } from 'src/Models/IprupdatesPageModel';
import { IPRstateMasterModel } from 'src/Models/IprstateMasterModel';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-ipr-updates',
  templateUrl: './updates.component.html',
  styleUrls: ['./updates.component.css']
})
export class IPRFrontUpdatesComponent implements OnInit {
  userID: number = 0;
  isAscending: boolean;
  statusCode: number = 0;
  appModel: any;
  upDowCarrierCSS: string = '';
  upDowStateNameCSS: string = '';
  upDowUpdateDateCSS: string = '';
  upDowDescriptionCSS: string = '';
  isloading: boolean = false;
  iscarrierloading: boolean = false;
  tokenKey: string = '';
  iprupdatesModel: IPRUpdatesModel[] = [];
  iprCarrierDetailModel: IPRUpdatesModel[] = [];
  favouriteUpdateModel: IPRUpdatesModel[] = [];
  isRecords: boolean = false;
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  totalRecordsCount: number = -1;
  queryParams: string = '';
  updateForm: FormGroup;
  totalunread: number = 0;
  alldata: string = 'all';
  unreaddata: string = 'unread';
  parameterModel = new IPRupdatesPageModel();
  parameterModelV2 = new IPRupdatesPageModelV2();

  baseUrl: string;

  //State List
  dropdownListState = [];
  selectedItemsState = [];
  dropdownSettingsState = {};
  stateFilter: string = '';

  listOfstateID: string[] = [];
  ClientSelectedTool: string;
  RegisteredChecked: boolean = true;
  NoLongerRegisteredChecked: boolean = true;
  ActiveStates: string = '';
  DeActiveStates: string = '';
  NotRegisteredStates: string = '';
  SelectedState: number = 0;
  IsNotificationSaved: boolean = false;
  CarrierName: string = '';
  FilterFavourite: number = 0;
  carrierFilter: string = '';
  IsFromPopup: number = 0;
  listofState: IPRstateMasterModel[];
  productId: number;
  pageNumber: number = 1;
  pageSize: number = 10;
  rangeOfupdatesDates: any;
  iprUnreadflag:boolean=true;
  iprUnread: number = 0;

  constructor(@Inject('BASE_URL') baseUrl: string,
    private readonly htmlToPdf: HtmlToPdf,
    private readonly iprupdatesService: iprupdatesService,
    private readonly toastr: ToastrService,
    private readonly titleService: Title,
    private readonly checkAuth: CheckAuth,
    private readonly router: Router,
    private readonly activedRoute: ActivatedRoute,
    private readonly appActivity: ApplicationActivityService,
    private sessionStorageService: SessionStorageService) {
    this.baseUrl = baseUrl;
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.userID = +sessionStorage.getItem('UserId');
    this.appModel = AppConfig.settings.ConnectionStrings;
    
    this.productId = ToolEnum.ipr;
    this.titleService.setTitle('Updates | JSi360');

    // Try to get token
    this.waitForTokenThenInit();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  private waitForTokenThenInit(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    if (!this.tokenKey) {
      console.warn('Token is empty, retrying in 100ms...');
      const interval = setInterval(() => {
        this.tokenKey = this.sessionStorageService.getTokenValue();
        if (this.tokenKey) {
          clearInterval(interval);
          this.afterTokenReady();
        }
      }, 100); // check every 100ms
    } else {
      this.afterTokenReady();
    }
  }

  /** Call what you normally do in ngOnInit */
  private afterTokenReady(): void {
    this.ClientSelectedTool = sessionStorage.getItem('ClientLoginTool');

    this.queryParams = this.activedRoute.snapshot.queryParams['data'];
    this.movetotop();
    this.parameterModelV2.keywordFilter = 'null';
    this.parameterModelV2.whereCondition = 'null';
    this.parameterModelV2.orderBy = 'UpdateDate DESC';
    this.upDowUpdateDateCSS = 'active';
    this.isAscending = true;
    this.parameterModelV2.fromupdatesDateFilter = "null";
    this.parameterModelV2.toupdatesDateFilter = "null";
    this.parameterModelV2.userID = this.userID.toString();
    this.parameterModelV2.updatetype = "1,0";
    this.parameterModelV2.pageNumber = this.pageNumber;
    this.parameterModelV2.pageSize = this.pageSize;
    this.isloading = false;
    this.GetIPRUpdates();
    this.GetStateData();
    this.GetIPRNotification();
  }

  ngOnInit() {
    
  }

  GetIPRUpdates(): void {
    this.isloading = true;
    this.tokenKey = this.sessionStorageService.getTokenValue();

    let iprReadflag= sessionStorage.getItem('iprUnreadflag');
    this.iprUnreadflag = iprReadflag === 'true' ? true : false;

    let iprUnreadcount= sessionStorage.getItem('iprUnread');

    this.iprUnread=parseInt(iprUnreadcount);

    if (!this.iprUnreadflag && this.iprUnread>0) {
      this.iprupdatesService.GetIPRUpdatesUnread(this.tokenKey, this.userID).subscribe(
        data => {
          if (data["status"] == "Success") {
            sessionStorage.setItem('iprUnreadflag', 'true');
            this.iprUnreadflag = true;
            this.iprupdatesModel = data["updates"];
            ApplicationActivityStore('View', 'IPR - Updates', this.appActivity, ToolEnum.ipr, ActionActivity.IPR, '/ipr/Update', null);

            if (this.iprupdatesModel.length > 0) {
              this.isRecords = true;
              this.totalRecordsCount = this.iprupdatesModel.length;
              if (!this.IsNotificationSaved) {
                this.saveNotification(this.iprupdatesModel);
                this.IsNotificationSaved = true;
              }
            }
            else {
              this.viewallupdates();
            }
          }
          else {
            this.showMessage('There is an issue while fetching data. Please try again.', 'Error', 'error');
          }
        },
        error => {
          this.statusCode = error
        },
        () => this.isloading = false
      );
    }
    else {
      this.iprupdatesService.GetIPRUpdatesV2(this.tokenKey, this.parameterModelV2.fromupdatesDateFilter.toString(), this.parameterModelV2.toupdatesDateFilter.toString(), this.parameterModelV2.updatetype, this.parameterModelV2.orderBy, this.parameterModelV2.keywordFilter, this.userID, this.FilterFavourite, this.carrierFilter, this.parameterModelV2.pageNumber, this.parameterModelV2.pageSize).subscribe(
        data => {
          this.isloading = false;
          if (data["status"] == "Success") {
            this.iprupdatesModel = data["updates"];
            ApplicationActivityStore('View', 'IPR - Updates', this.appActivity, ToolEnum.ipr, ActionActivity.IPR, '/ipr/Update', null);

            if (this.iprupdatesModel.length > 0) {
              this.isRecords = true;
              this.totalRecordsCount = Number(this.iprupdatesModel[0].totalRecordCount);
            }
            else {
              this.totalRecordsCount = 0;
              this.isRecords = false;
            }
          }
          else {
            this.showMessage('There is an issue while fetching data. Please try again.', 'Error', 'error');
          }
        },
        error => {
          this.statusCode = error
        },
        () => this.isloading = false
      );
    }
  }

  saveNotification(updates) {
    let updateId = updates.map(i => i.updateId).join(',');
    this.iprupdatesService.addNotification(this.userID, updateId, this.tokenKey).subscribe(data => {
      if (data.status == 'Success') {
        window.document.body.getElementsByClassName('unread')[0].setAttribute("style", "display:none");
      }
      else {
        this.showMessage(data.status, 'Error', 'error');
      }
    }, error => {
      this.showMessage(error, 'Error', 'error');
    });
  }

  sort(sortBy: string) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.parameterModelV2.orderBy = sortBy + ' DESC';
      if (sortBy === "BusinessName") {
        this.upDowCarrierCSS = 'active';
        this.upDowStateNameCSS = '';
        this.upDowUpdateDateCSS = '';
        this.upDowDescriptionCSS = '';
      }
      else if (sortBy === "StateName") {
        this.upDowCarrierCSS = '';
        this.upDowStateNameCSS = 'active';
        this.upDowUpdateDateCSS = '';
        this.upDowDescriptionCSS = '';
      }
      else if (sortBy === "UpdateDate") {
        this.upDowCarrierCSS = '';
        this.upDowStateNameCSS = '';
        this.upDowUpdateDateCSS = 'active';
        this.upDowDescriptionCSS = '';
      }
      else if (sortBy === "Description") {
        this.upDowCarrierCSS = '';
        this.upDowStateNameCSS = '';
        this.upDowUpdateDateCSS = '';
        this.upDowDescriptionCSS = 'active';
      }
    }
    else {
      this.isAscending = false;
      this.parameterModelV2.orderBy = sortBy;

      if (sortBy === "BusinessName") {
        this.upDowCarrierCSS = 'active-up';
        this.upDowStateNameCSS = '';
        this.upDowUpdateDateCSS = '';
        this.upDowDescriptionCSS = '';
      }
      else if (sortBy === "StateName") {
        this.upDowCarrierCSS = '';
        this.upDowStateNameCSS = 'active-up';
        this.upDowUpdateDateCSS = '';
        this.upDowDescriptionCSS = '';
      }
      else if (sortBy === "UpdateDate") {
        this.upDowCarrierCSS = '';
        this.upDowStateNameCSS = '';
        this.upDowUpdateDateCSS = 'active-up';
        this.upDowDescriptionCSS = '';
      }
      else if (sortBy === "Description") {
        this.upDowCarrierCSS = '';
        this.upDowStateNameCSS = '';
        this.upDowUpdateDateCSS = '';
        this.upDowDescriptionCSS = 'active-up';
      }
    }
    this.parameterModelV2.pageNumber = 1;
    this.GetIPRUpdates();
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  movetotop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 1);
  }

  keywordFilters($event) {
    this.parameterModelV2.pageNumber = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.parameterModelV2.keywordFilter = $event.target.value;
    else
      this.parameterModelV2.keywordFilter = 'null';

    this.GetIPRUpdates();
  }

  isUpdatesDatesFilter(value: any) {
    this.parameterModelV2.pageNumber = 1;
    if (value != null) {
      if (value.length == 2) {
        this.parameterModelV2.pageNumber = 1;
        const d = new Date(value[0]);
        const a = [this.pad(d.getMonth() + 1), this.pad(d.getDate()), d.getFullYear()].join('/');

        const e = new Date(value[1]);
        const f = [this.pad(e.getMonth() + 1), this.pad(e.getDate()), e.getFullYear()].join('/');

        this.parameterModelV2.fromupdatesDateFilter = a;
        this.parameterModelV2.toupdatesDateFilter = f;
       this.GetIPRUpdates();
      }
    }
  }

  pad(s) {
    return (s < 10) ? '0' + s : s;
  }

  updatesDateFilterClear() {
    this.rangeOfupdatesDates = [];
    this.parameterModelV2.fromupdatesDateFilter = "";
    this.parameterModelV2.toupdatesDateFilter = "";
    this.GetIPRUpdates();
  }

  updatesCarrierFilterClear() {
    this.parameterModelV2.pageNumber = 1;
    this.carrierFilter = '';
    this.GetIPRUpdates();
  }

  updatetypechange($event) {
    this.parameterModelV2.pageNumber = 1;
    if ($event.target.id == 'chkRegistered') {
      this.RegisteredChecked = $event.target.checked;
    }
    if ($event.target.id == 'chkNoLongerRegistered') {
      this.NoLongerRegisteredChecked = $event.target.checked;
    }
    if ($event.target.checked) {
      if (this.parameterModelV2.updatetype == "-1") { this.parameterModelV2.updatetype = "" }
      if (this.parameterModelV2.updatetype == '' || this.parameterModelV2.updatetype == 'null') {
        this.parameterModelV2.updatetype = $event.target.value;
      }
      else {
        this.parameterModelV2.updatetype += ',' + $event.target.value;
      }
    }
    else {
      this.parameterModelV2.updatetype = this.parameterModelV2.updatetype.replace($event.target.value, "");
      this.parameterModelV2.updatetype = this.parameterModelV2.updatetype.replace(/,\s*$/, "");
      this.parameterModelV2.updatetype = this.parameterModelV2.updatetype.replace(",,", ",");
      if (this.parameterModelV2.updatetype.charAt(0) == ",") {
        this.parameterModelV2.updatetype = this.parameterModelV2.updatetype.slice(1)
      }
      if (this.parameterModelV2.updatetype == "") { this.parameterModelV2.updatetype = "" }
    }
    this.GetIPRUpdates();
  }

  pdfDocument() {
    this.blockDocument();
    let mainURL = this.baseUrl;
    let url = '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Admin/AdminLTE.min.css"> <br> ';
    url += ' <link rel="stylesheet" href="' + mainURL + '/assets/css/bootstrap.min.css" asp-append-version="true" /> <br> ';
    url += ' <link id="adminstyle" rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"> <br> ';
    var html = url + document.getElementById('divPrint').innerHTML;
    this.htmlToPdf.CreatePDF(this.tokenKey, html, '0', this.productId).
      subscribe(data => {
        if (data['status'] == 'Success') {
          this.downloadFile('Update', data['url']);
        }
      },
        error => {
          this.statusCode = error;
          this.unblockDocument();
        }
      );

  }

  public downloadFile(filename, url) {
    this.htmlToPdf.downloadPdf(url).subscribe(
      (res) => {
        FileSaver.saveAs(res, filename);
        ApplicationActivityStore('Download', 'IPR Updates File download ' + filename, this.appActivity, ToolEnum.ipr, ActionActivity.IPR, '/ipr/updates/Details');

        sessionStorage.setItem('fileloading', 'false');
        this.unblockDocument();
      }
    );
  }

  GetStateData(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.iprupdatesService.GetStatesByUserID(this.tokenKey, this.userID, this.productId).subscribe(
      data => {
        if (data["state"] != null) {
          // Set All Item
          for (let iCounter = 0; iCounter < data["state"].length; iCounter++) {
            this.dropdownListState.push(
              { "id": data["state"][iCounter].stateId, "itemName": data["state"][iCounter].name }
            );
          }
        }
        else {
          this.showMessage(data["message"], 'Error', 'error');
          this.unblockDocument();
        }
        this.dropdownSettingsState = {
          singleSelection: false,
          text: "Select State(s)",
          enableSearchFilter: false,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 1,
          noDataLabel: 'No state available',
          showCheckbox: true,
          enableFilterSelectAll: false
        };
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  FilterSelecteventState($event) {
    this.parameterModelV2.pageNumber = 1;
    this.stateFilter = '';
    this.listOfstateID = this.removeElemetninArray(this.listOfstateID, $event['id']);
    this.listOfstateID.push($event.id);
    this.getString(this.listOfstateID);
    this.parameterModelV2.keywordFilter = this.stateFilter;
    this.GetIPRUpdates();
  }

  FilterDeSelectseventState($event) {
    this.parameterModelV2.pageNumber = 1;
    this.stateFilter = '';
    this.listOfstateID = this.removeElemetninArray(this.listOfstateID, $event['id']);
    this.getString(this.listOfstateID);
    this.parameterModelV2.keywordFilter = this.stateFilter;
    this.GetIPRUpdates();
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e != element);
  }

  getString(array: any) {
    let sprator = '';
    this.stateFilter = '';
    for (let iCounter = 0; iCounter < array.length; iCounter++) {
      this.stateFilter += sprator + array[iCounter];
      sprator = ',';
    }
  }

  onSelectAllStateList($event) {
    this.parameterModelV2.pageNumber = 1;
    this.stateFilter = '';
    if ($event != "" && $event != null) {
      for (let iCounter = 0; iCounter < $event.length; iCounter++) {
        this.listOfstateID = this.removeElemetninArray(this.listOfstateID, $event[iCounter].id);
        this.listOfstateID.push($event[iCounter].id);
      }
      this.getString(this.listOfstateID);
      this.parameterModelV2.keywordFilter = this.stateFilter;
    }
    this.GetIPRUpdates();
  }

  onDeSelectAllStateList($event) {
    this.parameterModelV2.pageNumber = 1;
    this.listOfstateID = [];
    this.stateFilter = '';
    this.parameterModelV2.keywordFilter = '';
    this.GetIPRUpdates();
  }

  GetCarrierDetailsByID(carrierId: number): void {
    this.RemoveCarrier();
    this.CarrierName = '';
    this.iscarrierloading = true;
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.iprupdatesService.GetIPRUpdatesFindByCarrierID(this.tokenKey, carrierId, this.productId).subscribe(
      data => {
        this.iprCarrierDetailModel = data["updates"];
        this.CarrierName = this.iprCarrierDetailModel[0].businessName;
        this.ActiveStates = this.iprCarrierDetailModel[0].listOfActiveStates.filter(i => i.isSelected == true).map(i => i.shortName).join(', ');
        this.DeActiveStates = this.iprCarrierDetailModel[0].listOfDeActiveStates.filter(i => i.isSelected == true).map(i => i.shortName).join(', ');
        this.NotRegisteredStates = this.iprCarrierDetailModel[0].listOfNotRegisteredStates.filter(i => i.isSelected == true).map(i => i.shortName).join(', ');
        ApplicationActivityStore('View', 'IPR - Updates', this.appActivity, ToolEnum.ipr, ActionActivity.IPR, '/ipr/Update/details', null);

        this.unblockDocument();
        this.iscarrierloading = false;
      },
      error => {
        this.statusCode = error;
        this.unblockDocument();
        this.iscarrierloading = false;
      }
    );
  }

  RemoveCarrier() {
    this.iprCarrierDetailModel = [];
    this.ActiveStates = '';
    this.DeActiveStates = '';
    this.NotRegisteredStates = '';
  }

  AddToFavourite(update, IsFavourite: number, IsFromPopup: number) {
    this.IsFromPopup = IsFromPopup;
    let StateId = update.stateId;
    if (IsFavourite == 0) {
      this.SelectedState = StateId;
      this.favouriteUpdateModel = update;
      var elem = document.getElementById("lnkFavouriteValidation");
      elem.click();
    }
    else {
      this.SaveFavourite(StateId, IsFavourite, update, IsFromPopup);
    }
  }

  UpdateStateFavourite(update, IsFavourite: number) {
    let filterState = this.iprupdatesModel.filter((i) => i.stateName === update.stateName);
    for (let li of filterState) {
      this.iprupdatesModel.filter((i) => i.updateId === li.updateId)[0].favourite = IsFavourite;
    }
  }

  viewallupdates() {
    this.queryParams = this.alldata;
    this.router.navigate(['/ipr/Updates'], { queryParams: { data: this.alldata } });
    this.GetIPRUpdates();
  }

  SaveFavourite(StateId: number, IsFavourite: number, update, IsFromPopup: number) {
    if (IsFromPopup == 0)
      this.blockDocument();
    document.getElementById("btnClose").click();
    this.iprupdatesService.ClientStateFavouriteAdd(this.tokenKey, this.userID, String(StateId), IsFavourite)
      .subscribe(data => {
        if (data["status"] == "Success") {
          if (IsFavourite == 1) {
            this.showMessage('Selected state added successfully to favorite list.', 'Favorite', 'success');
          }
          else {
            this.showMessage('Selected state removed successfully from favorite list.', 'Favorite', 'success');
          }
          if (IsFromPopup == 0) {
            this.UpdateStateFavourite(update, IsFavourite);
          }
          else {
            update.favourite = IsFavourite;
          }
        }
        else {
          this.showMessage(data["status"], 'Error', 'error');
        }
        this.unblockDocument();
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  GetFavourite(IsFavourite: number) {
    this.parameterModelV2.pageNumber = 1;
    if (IsFavourite == 1) {
      this.FilterFavourite = 1;
    }
    else {
      this.FilterFavourite = 0;
    }

    this.GetIPRUpdates();
  }

  carrrierFilters($event) {
    this.parameterModelV2.pageNumber = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.carrierFilter = $event.target.value;
    else
      this.carrierFilter = '';

    this.GetIPRUpdates();
  }

  GetStatesForFavorites() {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.iprupdatesService.GetStatesByUserID(this.tokenKey, this.userID, this.productId).subscribe(
      data => {
        this.listofState = data["state"]
      }, error => {
      })
  }

  CloseStatePopup() {
    this.GetIPRUpdates();
  }

  ngAfterViewInit() {
    this.setEmailAutoLoginParameter();
  }

  setEmailAutoLoginParameter() {
    if (sessionStorage.getItem('DisplayMessage') != null) {
      this.showMessage(sessionStorage.getItem('DisplayMessage') + ' - user not have access', 'Error', 'error');
      sessionStorage.removeItem('DisplayMessage');
    }
  }

  pageChanged($event: any) {
    this.parameterModelV2.pageNumber = $event.page;
    this.GetIPRUpdates();
  }

  GetIPRNotification(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.userID = +sessionStorage.getItem('UserId');
    this.iprupdatesService.GetIPRUpdatesUnread(this.tokenKey, this.userID).subscribe(
      data => {
        if (data["status"] == "Success") {
          this.iprUnread = data["updates"].length;
          sessionStorage.setItem('iprUnread', this.iprUnread.toString());

          if (this.iprUnread > 0) {
            sessionStorage.setItem('iprUnreadflag', 'false');
            this.iprUnreadflag=false;
          }
        }
      },
      error => {
        
      },
    );
  }
}
